/**
 * Canonical public path for a product detail page.
 *
 * Prefers the descriptive `slug`; falls back to the stable `id` (UUID) for any
 * legacy row whose slug hasn't been backfilled yet. Single source of truth —
 * every place that links to `/p/...` must use this so the slug switch stays
 * consistent everywhere.
 *
 * Kept in its own dependency-free module (no Drizzle / D1 imports) so CLIENT
 * components can use it without pulling the server-only product DB layer into
 * the browser bundle. `lib/products` re-exports it for server callers.
 */
export function productPath(p: { slug?: string | null; id: string }): string {
  return `/p/${encodeURIComponent(p.slug || p.id)}`;
}
